import {hasRole} from '../../utils/hasRole';
import React, {useState, useEffect} from 'react';
import {useHistory, useLocation, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import {TabView, TabPanel} from "primereact/tabview";
import {Button} from "primereact/button";
import axios from "axios";

import CandidateListComponent from "../../components/2.1/recruitment/candidate/CandidateListComponent";
import CandidateShowComponent from "../../components/2.1/recruitment/candidate/CandidateShowComponent";
import CandidateFormComponent from '../../components/2.1/recruitment/candidate/CandidateFormComponent';
import CandidateEducationList from "../../components/2.1/recruitment/candidate/CandidateEducationListComponent";
import CandidateLanguageList from "../../components/2.1/recruitment/candidate/CandidateLanguageListComponent";
import CandidateWorkexperienceList from "../../components/2.1/recruitment/candidate/CandidateWorkexperienceListComponent";
import CandidateNoteList from "../../components/2.1/recruitment/candidate/CandidateNoteListComponent";
import CandidateNoteFormComponent from "../../components/2.1/recruitment/candidate/CandidateNoteFormComponent";
import CandidateEducationFormComponent from "../../components/2.1/recruitment/candidate/CandidateEducationFormComponent";
import CandidateLanguageFormComponent from "../../components/2.1/recruitment/candidate/CandidateLanguageFormComponent";
import CandidateWorkexperienceFormComponent from "../../components/2.1/recruitment/candidate/CandidateWorkexperienceFormComponent";
import RecruitmentDashboardComponent from '../../components/2.1/recruitment/RecruitmentDashboardComponent';
import RecruitmentListComponent from '../../components/2.1/recruitment/recruitment/RecruitmentListComponent';
import RecruitmentFormComponent from '../../components/2.1/recruitment/recruitment/RecruitmentFormComponent';
import EventtypestatusListComponent from '../../components/2.1/recruitment/event-type-status/EventtypestatusListComponent';
import EventtypestatusFormComponent from '../../components/2.1/recruitment/event-type-status/EventtypestatusFormComponent';
import EventtypeListComponent from '../../components/2.1/recruitment/event-type/EventtypeListComponent';
import EventtypeFormComponent from '../../components/2.1/recruitment/event-type/EventtypeFormComponent';
import RecruitmentShowComponent from '../../components/2.1/recruitment/recruitment/RecruitmentShowComponent';
import RecruitmentEventCandidateListComponent from '../../components/2.1/recruitment/recruitment/RecruitmentEventCandidateListComponent';
import DocsListComponent from "../../components/2.1/docs/DocsListComponent";
import DocsFormComponent from "../../components/2.1/docs/DocsFormComponent";
import DocsUploadComponent from "../../components/2.1/docs/DocsUploadComponent";
import CandidateImportComponent from '../../components/2.1/recruitment/candidate/CandidateImportComponent';
import RecruitmentBreadcrumb from '../../components/2.1/recruitment/RecruitmentBreadcrumb';
import CandidateJournal from '../../components/2.1/recruitment/candidate/CandidateJournal';

export const RecruitmentPage = (props) => {
  const {t} = props;

  const history = useHistory();
  const location = useLocation();
  const {entity, action, id} = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState(() => window.App.urlVars().tab === '3' ? 3 : 0);
  useEffect(() => {
    setActiveTabIndex(new URLSearchParams(location.search).get('tab') === '3' ? 3 : 0);
  }, [id, entity, location.search]);
  const [candidate, setCandidate] = useState(null);
  const canReadDashboard = hasRole('ROLE_RECRUITMENT_MODULE_DASHBOARD');

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    document.title = 'Toborzás' + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('recruitment')[0]) {
        document.getElementsByClassName('recruitment')[0].classList.add("activeMenu")
      }
    }, 1000)
  }, [window.App.state.rerenderRecruitmentPage]);

  useEffect(() => {
    if (entity === 'candidate' && action === 'read') {
      apiCall('get', `/api/v2/candidate/${id}`)
        .then(response => {
          setCandidate(response.data.data);
        });
    }
  }, [entity, action, id, window.App.state.rerenderCandidateEducationList, window.App.state.rerenderCandidateLanguageList, 
    window.App.state.rerenderCandidateWorkexperienceList, window.App.state.rerenderCandidateNoteList]);

  useEffect(() => {
    if (entity === 'candidate' && action === 'read') {
      apiCall('get', `/api/v2/candidate/${id}`)
        .then(res => setCandidate(res.data.data));
    }
  }, [entity, action, id, window.App.state.rerenderCandidateEducationList]);

  return (
    <div className={"RecruitmentPage"}>

      {/* <SubstitutionFormComponent />
      <SubstitutionListComponent /> */}
      {/* <VatrateFormComponent />
      <VatrateListComponent /> */}


      {localStorage.getItem('module_recruitment') ? (
        <>
          <RecruitmentBreadcrumb candidateName={candidate?.name}/>
          {entity === 'candidate-import' && (localStorage.getItem('roles') || '').includes('role_recruitment_candidate_read') && <div className="PageContent p-p-5 p-mx-auto"><h2 className="text-primary">{t('recruitmentImport.title')}</h2><CandidateImportComponent/></div>}
          {entity === 'dashboard' && canReadDashboard &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <RecruitmentDashboardComponent />
            </div>
          }
          {entity === 'candidate' && action === 'read' &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {candidate?.name}
                  </h2>
                </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <div className="p-d-inline-flex" style={{ gap: 8 }}>
                      <a
                        onClick={() => {
                          history.push('/recruitment/candidate')
                        }}
                        className={"p-button  p-button-secondary p-ml-2"}
                      >
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
              </div>
              <Panel>
                <TabView className="tabview-header-icon menu" style={{border: 'none'}} activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
                  <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-xl-8"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          </div>
                           <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                              <Button
                                icon="pi pi-pencil"
                                className="p-button-warning p-button-sm p-ml-2"
                                label={t('editData')}
                                onClick={() => history.push(`/recruitment/candidate/read/${id}?update=candidate`)}
                              />
                            </div>
                          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                            
                          </div>
                        </div>
                        <CandidateShowComponent/>
                      </div>
                     <div className={"p-col-12 p-xl-4"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>{t('educations')}</h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <Button
                              icon="pi pi-plus"
                              className="p-button-success p-button-sm p-ml-2"
                              label={t('addEducation')}
                              onClick={() => {
                                history.push(`/recruitment/candidate/read/${id}?create=candidate-education&candidateId=${id}`)
                              }}
                            />
                          </div>
                        </div>
                        {candidate && <CandidateEducationList educations={candidate.educations || []} />}
                        <div className={"p-grid p-mt-3"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>{t('languageKnowledge')}</h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <Button
                              icon="pi pi-plus"
                              className="p-button-success p-button-sm p-ml-2"
                              label={t('addLanguageKnowledge')}
                              onClick={() => {
                                history.push(`/recruitment/candidate/read/${id}?create=candidate-language&candidateId=${id}`)
                              }}
                            />
                          </div>
                        </div>
                        {candidate && <CandidateLanguageList languages={candidate.languages || []} />}
                        <div className={"p-grid p-mt-3"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>{t('workExperience')}</h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <Button
                              icon="pi pi-plus"
                              className="p-button-success p-button-sm p-ml-2"
                              label={t('addWorkExperience')}
                              onClick={() => {
                                history.push(`/recruitment/candidate/read/${id}?create=candidate-work-experience&candidateId=${id}`)
                              }}
                            />
                          </div>
                        </div>
                        {candidate && <CandidateWorkexperienceList workexperiences={candidate.work_experiences || []} />}
                        <div className={"p-grid p-mt-3"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>{t('notes')}</h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <Button
                              icon="pi pi-plus"
                              className="p-button-success p-button-sm p-ml-2"
                              label={t('addNote')}
                              onClick={() => {
                                history.push(`/recruitment/candidate/read/${id}?create=candidate-note&candidateId=${id}`)
                              }}
                            />
                          </div>
                        </div>
                        {candidate && <CandidateNoteList notes={candidate.notes || []} />}
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header={t('tabDocuments')} leftIcon="pi pi-file">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('candidateDocuments')}
                        </h3>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <Button icon="pi pi-plus" className="p-button-success p-button-sm p-ml-2"
                                label={t('addDocumentFromTemplate')} tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  history.push('/recruitment/candidate/read/' + id + '?create=docs')
                                }}/>
                        <Button icon="pi pi-upload" className="p-button-success p-button-sm p-ml-2"
                                label={t('uploadDocument')} tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  history.push('/recruitment/candidate/read/' + id + '?upload=docs')
                                }}/>
                      </div>
                    </div>
                    <DocsListComponent/>
                  </TabPanel>
                <TabPanel header={t('candidateJournal.activities')} leftIcon="pi pi-list">
                    {activeTabIndex === 2 && <CandidateJournal candidateId={id} kind="activities"/>}
                  </TabPanel>
                  <TabPanel header={t('candidateJournal.applications')} leftIcon="pi pi-history">
                    {activeTabIndex === 3 && <CandidateJournal candidateId={id} kind="applications"/>}
                  </TabPanel>
                </TabView>
              </Panel>
            </div>
          }

          {entity === 'candidate' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_recruitment_candidate_read') && 
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('candidateList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_recruitment_candidate_write') && (
                    <>
                    <Button icon="pi pi-upload" className="p-button-secondary p-ml-2" label={t('recruitmentImport.title')} onClick={() => history.push('/recruitment/candidate-import')}/>
                    <a onClick={() => {
                      history.push('/recruitment/candidate/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addCandidate')}
                    </a>
                    </>
                  )}
                </div>
              </div>
              <Panel>
                <CandidateListComponent backlink={'/recruitment/candidate'}/>
              </Panel>
            </div>
          }
          {entity === 'candidate' && (action === 'create' || action === 'update' || window.App.urlVars().update === 'candidate') &&
                      <Sidebar position="left"
                               showCloseIcon={false}
                               visible={action === 'create' || action === 'update' || window.App.urlVars().update === 'candidate'}
                               closeOnEscape={true}
                               style={{width: '780px'}}
                               onHide={() => {
                                 if (action === 'create' || action === 'update') {
                                   history.push('/recruitment/candidate')
                                 }
                                 if (action === 'read' && id && window.App.urlVars().update === 'candidate') {
                                    history.push(`/recruitment/candidate/read/${id}`);
                                  }
                               }}>
                        <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {id ? t('candidateUpdate') : t('candidateCreate')}
                              </h2>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <span className={"p-mr-2"}>
          
                            </span>
                              <a onClick={() => {
                                if (action === 'create' || action === 'update') {
                                  history.push('/recruitment/candidate')
                                }
                                if (action === 'read' && id && window.App.urlVars().update === 'candidate') {
                                  history.push(`/recruitment/candidate/read/${id}`);
                                }
                              }}
                                 className={"p-button  p-button-secondary p-ml-2"}>
                                <i className={"pi pi-arrow-left"}></i>
                                &nbsp;
                                {t('back')}
                              </a>
                            </div>
                          </div>
                          <Panel>
                            {(action === 'create' || action === 'update') &&
                              <CandidateFormComponent backlink={'/recruitment/candidate'}/>
                            }
                            {(action === 'read' && id && window.App.urlVars().update === 'candidate') && (
                              <CandidateFormComponent candidateId={id} backlink={`/recruitment/candidate/read/${id}`} />
                            )}
                          </Panel>
                        </div>
                      </Sidebar>
                    }
                    {entity === 'candidate' && action === 'read' && (window.App.urlVars().create === 'docs' || window.App.urlVars().update === 'docs') &&
                      <Sidebar
                        position="left"
                        showCloseIcon={false}
                        visible={window.App.urlVars().create === 'docs' || window.App.urlVars().update === 'docs'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          history.push('/recruitment/candidate/read/' + id)
                        }}
                      >
                        <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                Dokumentum sablonból
                              </h2>
                            </div>

                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <a
                                onClick={() => {
                                  history.push('/recruitment/candidate/read/' + id)
                                }}
                                className={"p-button p-button-secondary p-ml-2"}
                              >
                                <i className={"pi pi-arrow-left"}></i>
                                &nbsp;
                                {t('back')}
                              </a>
                            </div>
                          </div>

                          <Panel>
                            <DocsFormComponent backlink={'/recruitment/candidate/read/' + id}/>
                          </Panel>
                        </div>
                      </Sidebar>
                    }

                    {entity === 'candidate' && action === 'read' && window.App.urlVars().upload === 'docs' &&
                      <Sidebar
                        position="left"
                        showCloseIcon={false}
                        visible={window.App.urlVars().upload === 'docs'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          history.push('/recruitment/candidate/read/' + id)
                        }}
                      >
                        <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                Dokumentum feltöltése
                              </h2>
                            </div>

                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <a
                                onClick={() => {
                                  history.push('/recruitment/candidate/read/' + id)
                                }}
                                className={"p-button p-button-secondary p-ml-2"}
                              >
                                <i className={"pi pi-arrow-left"}></i>
                                &nbsp;
                                {t('back')}
                              </a>
                            </div>
                          </div>

                          <Panel>
                            <DocsUploadComponent backlink={'/recruitment/candidate/read/' + id}/>
                          </Panel>
                        </div>
                      </Sidebar>
                    }
                    {entity === 'candidate' && action === 'read' &&  (window.App.urlVars().create === 'candidate-education' || 
                      window.App.urlVars().update === 'candidate-education') &&
                        <Sidebar position="left"
                                  showCloseIcon={false}
                                  visible={window.App.urlVars().create === 'candidate-education' ||
                                          window.App.urlVars().update === 'candidate-education'}
                                  closeOnEscape={true}
                                  style={{width: '780px'}}
                                  onHide={() => history.push(`/recruitment/candidate/read/${id}`)}
                                  >
                          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                            <div className={"p-grid"}>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                  {window.App.urlVars().candidateEducationId ? t('educationUpdate') : t('educationCreate')}
                                </h2>
                              </div>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <span className={"p-mr-2"}>
            
                              </span>
                                <a onClick={() => {
                                  if (action === 'create' || action === 'update' || action === 'read') {
                                    history.push(`/recruitment/candidate/read/${id}`)
                                  }
                                }}
                                    className={"p-button  p-button-secondary p-ml-2"}>
                                  <i className={"pi pi-arrow-left"}></i>
                                  &nbsp;
                                  {t('back')}
                                </a>
                              </div>
                            </div>
                            <Panel>
                              {(action === 'create' || action === 'update' || action === 'read') &&
                                <CandidateEducationFormComponent candidateId={id} backlink={`/recruitment/candidate/read/${id}/candidate-education`}/>
                              }
                            </Panel>
                          </div>
                        </Sidebar>
                      }

                      {entity === 'candidate' && action === 'read' &&  (window.App.urlVars().create === 'candidate-language' || 
                      window.App.urlVars().update === 'candidate-language') &&
                        <Sidebar position="left"
                                  showCloseIcon={false}
                                  visible={window.App.urlVars().create === 'candidate-language' ||
                                          window.App.urlVars().update === 'candidate-language'}
                                  closeOnEscape={true}
                                  style={{width: '780px'}}
                                  onHide={() => history.push(`/recruitment/candidate/read/${id}`)}
                                  >
                          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                            <div className={"p-grid"}>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                  {window.App.urlVars().candidateLanguageId ? t('languageKnowledgeUpdate') : t('languageKnowledgeCreate')}
                                </h2>
                              </div>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <span className={"p-mr-2"}>
            
                              </span>
                                <a onClick={() => {
                                  if (action === 'create' || action === 'update' || action === 'read') {
                                    history.push(`/recruitment/candidate/read/${id}`)
                                  }
                                }}
                                    className={"p-button  p-button-secondary p-ml-2"}>
                                  <i className={"pi pi-arrow-left"}></i>
                                  &nbsp;
                                  {t('back')}
                                </a>
                              </div>
                            </div>
                            <Panel>
                              {(action === 'create' || action === 'update' || action === 'read') &&
                                <CandidateLanguageFormComponent candidateId={id} backlink={`/recruitment/candidate/read/${id}/candidate-language`}/>
                              }
                            </Panel>
                          </div>
                        </Sidebar>
                      }


                      {entity === 'candidate' && action === 'read' &&  (window.App.urlVars().create === 'candidate-work-experience' || 
                      window.App.urlVars().update === 'candidate-work-experience') &&
                        <Sidebar position="left"
                                  showCloseIcon={false}
                                  visible={window.App.urlVars().create === 'candidate-work-experience' ||
                                          window.App.urlVars().update === 'candidate-work-experience'}
                                  closeOnEscape={true}
                                  style={{width: '780px'}}
                                  onHide={() => history.push(`/recruitment/candidate/read/${id}`)}
                                  >
                          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                            <div className={"p-grid"}>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                  {window.App.urlVars().candidateWorkexperienceId ? t('workExperienceUpdate') : t('workExperienceCreate')}
                                </h2>
                              </div>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <span className={"p-mr-2"}>
            
                              </span>
                                <a onClick={() => {
                                  if (action === 'create' || action === 'update' || action === 'read') {
                                    history.push(`/recruitment/candidate/read/${id}`)
                                  }
                                }}
                                    className={"p-button  p-button-secondary p-ml-2"}>
                                  <i className={"pi pi-arrow-left"}></i>
                                  &nbsp;
                                  {t('back')}
                                </a>
                              </div>
                            </div>
                            <Panel>
                              {(action === 'create' || action === 'update' || action === 'read') &&
                                <CandidateWorkexperienceFormComponent candidateId={id} backlink={`/recruitment/candidate/read/${id}/candidate-work-experience`}/>
                              }
                            </Panel>
                          </div>
                        </Sidebar>
                      }


                      {entity === 'candidate' && action === 'read' &&  (window.App.urlVars().create === 'candidate-note' || 
                      window.App.urlVars().update === 'candidate-note') &&
                        <Sidebar position="left"
                                  showCloseIcon={false}
                                  visible={window.App.urlVars().create === 'candidate-note' ||
                                          window.App.urlVars().update === 'candidate-note'}
                                  closeOnEscape={true}
                                  style={{width: '780px'}}
                                  onHide={() => history.push(`/recruitment/candidate/read/${id}`)}
                                  >
                          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                            <div className={"p-grid"}>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                  {window.App.urlVars().candidateNoteId ? t('noteUpdate') : t('noteCreate')}
                                </h2>
                              </div>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <span className={"p-mr-2"}>
            
                              </span>
                                <a onClick={() => {
                                  if (action === 'create' || action === 'update' || action === 'read') {
                                    history.push(`/recruitment/candidate/read/${id}/candidate-note`)
                                  }
                                }}
                                    className={"p-button  p-button-secondary p-ml-2"}>
                                  <i className={"pi pi-arrow-left"}></i>
                                  &nbsp;
                                  {t('back')}
                                </a>
                              </div>
                            </div>
                            <Panel>
                              {(action === 'create' || action === 'update' || action === 'read') &&
                                <CandidateNoteFormComponent candidateId={id} backlink={`/recruitment/candidate/read/${id}/candidate-note`}/>
                              }
                            </Panel>
                          </div>
                        </Sidebar>
                      }


          {entity === 'recruitment' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_recruitment_read') &&
                      <div className={"PageContent p-p-5 p-mx-auto"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                              {t('recruitmentWorkflow.selections')}
                            </h2>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <span className={"p-mr-2"}>
          
                            </span>
                            {localStorage.getItem('roles').toString().includes('role_recruitment_write') && (
                              <a onClick={() => {
                                history.push('/recruitment/recruitment/create')
                              }}
                                 className={"p-button  p-button-success p-ml-2"}>
                                <i className={"pi pi-plus"}></i>
                                &nbsp;
                                {t('recruitmentWorkflow.newSelection')}
                              </a>
                            )}
                          </div>
                        </div>
                        <Panel>
                          <RecruitmentListComponent backlink={'/recruitment/recruitment'}/>
                        </Panel>
                      </div>
                    }
                    {entity === 'recruitment' && (action === 'create' || action === 'update') &&
                      <Sidebar position="left"
                               showCloseIcon={false}
                               visible={action === 'create' || action === 'update'}
                               closeOnEscape={true}
                               style={{width: '780px'}}
                               onHide={() => {
                                 if (action === 'create' || action === 'update') {
                                   history.push('/recruitment/recruitment')
                                 }
                               }}>
                        <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {id ? t('candidateUpdate') : t('candidateCreate')}
                              </h2>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <span className={"p-mr-2"}>
          
                            </span>
                              <a onClick={() => {
                                if (action === 'create' || action === 'update') {
                                  history.push('/recruitment/recruitment')
                                }
                              }}
                                 className={"p-button  p-button-secondary p-ml-2"}>
                                <i className={"pi pi-arrow-left"}></i>
                                &nbsp;
                                {t('back')}
                              </a>
                            </div>
                          </div>
                          <Panel>
                            {(action === 'create' || action === 'update') &&
                              <RecruitmentFormComponent backlink={'/recruitment/recruitment'}/>
                            }
                          </Panel>
                        </div>
                      </Sidebar>
                    }



          {entity === 'event-type-status' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_recruitment_event_type_status_read') &&
                      <div className={"PageContent p-p-5 p-mx-auto"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                              {t('eventTypeList')}
                            </h2>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <span className={"p-mr-2"}>
          
                            </span>
                            {localStorage.getItem('roles').toString().includes('role_recruitment_event_type_status_write') && (
                              <a onClick={() => {
                                history.push('/recruitment/event-type-status/create')
                              }}
                                 className={"p-button  p-button-success p-ml-2"}>
                                <i className={"pi pi-plus"}></i>
                                &nbsp;
                                {t('addEventType')}
                              </a>
                            )}
                          </div>
                        </div>
                        <Panel>
                          <EventtypestatusListComponent backlink={'/recruitment/event-type-status'}/>
                        </Panel>
                      </div>
                    }
                    {entity === 'event-type-status' && (action === 'create' || action === 'update') &&
                      <Sidebar position="left"
                               showCloseIcon={false}
                               visible={action === 'create' || action === 'update'}
                               closeOnEscape={true}
                               style={{width: '780px'}}
                               onHide={() => {
                                 if (action === 'create' || action === 'update') {
                                   history.push('/recruitment/event-type-status')
                                 }
                               }}>
                        <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {id ? t('eventTypeUpdate') : t('eventTypeCreate')}
                              </h2>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <span className={"p-mr-2"}>
          
                            </span>
                              <a onClick={() => {
                                if (action === 'create' || action === 'update') {
                                  history.push('/recruitment/event-type-status')
                                }
                              }}
                                 className={"p-button  p-button-secondary p-ml-2"}>
                                <i className={"pi pi-arrow-left"}></i>
                                &nbsp;
                                {t('back')}
                              </a>
                            </div>
                          </div>
                          <Panel>
                            {(action === 'create' || action === 'update') &&
                              <EventtypestatusFormComponent backlink={'/recruitment/event-type-status'}/>
                            }
                          </Panel>
                        </div>
                      </Sidebar>
                    }

          {entity === 'event-type' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_recruitment_event_type_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('eventTypeList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_recruitment_event_type_write') && (
                    <a onClick={() => {
                      history.push('/recruitment/event-type/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addEventType')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <EventtypeListComponent backlink={'/recruitment/event-type'}/>
              </Panel>
            </div>
          }
          {entity === 'recruitment' && action === 'read' &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('recruitmentWorkflow.events')}
                  </h2>
                </div>

                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <a
                    onClick={() => {
                      history.push(`/recruitment/recruitment-event-candidate?type=recommended&recruitmentId=${id}`)
                    }}
                    className={"p-button p-button-secondary p-ml-2"}
                  >
                    Ajánlott
                  </a>

                  <a
                    onClick={() => {
                      history.push(`/recruitment/recruitment-event-candidate?type=new&recruitmentId=${id}`)
                    }}
                    className={"p-button p-button-secondary p-ml-2"}
                  >
                    {t('addApplicants')}
                  </a>

                  <a
                    onClick={() => {
                      history.push(`/recruitment/recruitment-event-candidate?type=dropout&recruitmentId=${id}`)
                    }}
                    className={"p-button p-button-secondary p-ml-2"}
                  >
                    Kiesettek
                  </a>

                  <a
                    onClick={() => {
                      history.push(`/recruitment/recruitment-event-candidate?type=all&recruitmentId=${id}`)
                    }}
                    className={"p-button p-button-secondary p-ml-2"}
                  >
                    Összes
                  </a>

                  <a
                    onClick={() => {
                      history.push(`/recruitment/recruitment-event-candidate?type=results&recruitmentId=${id}`)
                    }}
                    className={"p-button p-button-secondary p-ml-2"}
                  >
                    Eredmények
                  </a>
                  
                  <a
                    onClick={() => {
                      history.push('/recruitment/recruitment')
                    }}
                    className={"p-button p-button-secondary p-ml-2"}
                  >
                    <i className={"pi pi-arrow-left"}></i>
                    &nbsp;
                    {t('back')}
                  </a>
                </div>
              </div>

              <Panel>
                <RecruitmentShowComponent backlink={'/recruitment/recruitment'} />
              </Panel>
            </div>
          }
          {entity === 'event-type' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                      showCloseIcon={false}
                      visible={action === 'create' || action === 'update'}
                      closeOnEscape={true}
                      style={{width: '780px'}}
                      onHide={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/recruitment/event-type')
                        }
                      }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('eventTypeUpdate') : t('eventTypeCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/recruitment/event-type')
                      }
                    }}
                        className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <EventtypeFormComponent backlink={'/recruitment/event-type'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }

          {entity === 'recruitment-event-candidate' && (!action || action === 'update' || action === 'create') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('candidateListSingular')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                </div>
              </div>
              <Panel>
                <RecruitmentEventCandidateListComponent backlink={'/recruitment/recruitment-event-candidate'}/>
              </Panel>
            </div>
          }
        </>
      ) : (
        <p className={"p-text-center p-my-5 p-py-5"}>
          <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
          <span className={"p-text-bold p-d-block "}>Ehhez a modulhoz sajnos nem rendelkezel hozzáféréssel.</span>
          Amennyiben további információra van szükséged írj emailt a {process.env.REACT_APP_DEVOPS_CONTACT} címre.
          {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
            <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;Előfizetői fiók áttekintése
                       </a>
                   </span>
          }
        </p>
      )
      }
    </div>
  )
}
export default withTranslation('common')(RecruitmentPage);
